import { Directive, OnInit, Input, ElementRef } from "@angular/core";
import { TokenService } from "../services/token.service";

@Directive({
  selector: "[appPermsRolesDisabled]",
})
export class PermsRolesDisabledDirective implements OnInit {
  @Input("appPermsRolesDisabled") requiredPermission;

  private userRoles = [];

  constructor(private el: ElementRef, private tokenService: TokenService) {
    this.userRoles = this.tokenService.getRoles();
  }

  ngOnInit(): void {
    if (this.checkPermission()) {
      this.el.nativeElement.disabled = true;
    }
  }

  private checkPermission(): boolean {
    let permissions: string[] = [];
    if (this.requiredPermission.includes(",")) {
      permissions = this.requiredPermission.split(",");
    } else {
      permissions.push(this.requiredPermission);
    }
    let permissionStatus = false;
    if (this.userRoles && permissions) {
      this.userRoles.forEach((element) => {
        if (permissions.indexOf(element) > -1) {
          permissionStatus = true;
        }
      });
    }
    return permissionStatus;
  }
}
